import { useNavigate, useParams } from 'react-router-dom';
import { useIcebreakers } from '../lib/content';
import IcebreakerDeck from '../components/IcebreakerDeck';
import OfflinePill from '../components/OfflinePill';
import { IconChat } from '../components/Icon';

/**
 * Videet's Terrible Icebreakers, as a page of its own (D62).
 *
 * **The deck's home is the Schedule now**, where it replaced "Coming in" — in
 * the rail on a laptop and behind a switcher on a phone. This route survives
 * because a single card is worth sending somebody, and a link has to open: the
 * page exists for `/icebreakers/<id>` more than for `/icebreakers`.
 *
 * It is not gated on the week and the Schedule's copy is, for that reason. A
 * link sent in October must still work; a switcher offering a card game beside
 * the programme in October is clutter.
 *
 * Everything the deck actually does lives in `IcebreakerDeck` and `lib/deck`,
 * so this file is the page furniture and the URL sync and nothing else.
 */
export default function Icebreakers() {
  const { cardId } = useParams();
  const navigate = useNavigate();
  const doc = useIcebreakers();

  if (doc.error && !doc.data) {
    return (
      <div className="page page-narrow">
        <div className="empty">
          <IconChat size={40} className="mark" />
          <h4 style={{ margin: 0 }}>Can't reach the cards</h4>
          <p>They live in a file we fetch, and it didn't come back. Try again in a moment.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page page-narrow ice-page">
      <OfflinePill fetchedAt={doc.fetchedAt} />

      <div className="ice-head">
        <h4>{doc.data?.title}</h4>
        <p>{doc.data?.intro}</p>
      </div>

      <IcebreakerDeck
        cards={doc.data?.cards ?? []}
        entryId={cardId}
        // `replace`, so swiping thirty cards does not bury the back button
        // under thirty history entries — the same call `PhotoDetail` makes.
        onCardChange={(id) => navigate(id ? `/icebreakers/${id}` : '/icebreakers', { replace: true })}
      />
    </div>
  );
}
